import {
    MERCHANTHISTORY_SUCCESS,
    MERCHANTHISTORY_FAILED,
    RESET_MERCHANTHISTORY,
    LOADING_MERCHANTHISTORY,
    NETWORK_ERROR_MERCHANTHISTORY
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_MERCHANTHISTORY:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case MERCHANTHISTORY_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case MERCHANTHISTORY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_MERCHANTHISTORY:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_MERCHANTHISTORY:
            return (state = initialState);
        default:
            return state;
    }
};
